import * as React from 'react'
import { getMyUser } from '../../store/session/selectors'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import HomeClient from './HomeClient'
import HomeCalendar from './HomeCalendar'
import { paths } from '../../app/constants'

const Home: React.FC = () => {
    const user = useSelector(getMyUser)
    if(!user) return null

    // Check if client has no businesses/clinics associated
    if (user.isClient && (!user.businesses || user.businesses.length === 0)) {
        return <Redirect to={paths.noClinics()} />
    }

    return user.isClient ? <HomeClient /> : <HomeCalendar />
}

export default Home